var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { BASE_FONT, SIZE_XXXL, SPACING_M, BASE_BORDER_WIDTH, createUIElement } from "../../helpers";
import { Icon, ICON_SIZES } from "../../Icon";
import { GoBackSvg } from '../assets/GoBackSvg';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    min-height: ", ";\n    padding: 0 ", ";\n    background-color: ", ";\n    cursor: pointer;\n    border-bottom: ", " dashed ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    min-height: ", ";\n    padding: 0 ", ";\n    background-color: ", ";\n    cursor: pointer;\n    border-bottom: ", " dashed ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), SIZE_XXXL, SPACING_M, function (_a) {
    var theme = _a.theme;
    return theme.colorNavBackground;
}, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderNeutral;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorNavHover;
});
var Text = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: ", ";\n    font: ", ";\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    margin-left: ", ";\n    font: ", ";\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])), SPACING_M, BASE_FONT, function (_a) {
    var theme = _a.theme;
    return theme.colorTextNavRest;
});
export var GoBackButton = createUIElement('GoBackButton', function (_a, ref) {
    var className = _a.className, text = _a.text, icon = _a.icon, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "text", "icon", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'navigation-back', className: "vm-GoBackButton " + className, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(Icon, { src: icon || React.createElement(GoBackSvg, null), size: ICON_SIZES.xl }),
        React.createElement(Text, null, text)));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=GoBackButton.js.map